import LocationPageTemplate from '@/components/locations/LocationPageTemplate';

const WestlakeVillagePage = () => (
  <LocationPageTemplate
    city="Westlake Village"
    path="/westlake-village"
    postalCode="91361"
    latitude={34.1459}
    longitude={-118.8048}
    metaTitle="Pressure Washing & Cleaning Services in Westlake Village, CA | Ventura Power Washing"
    metaDescription="Hot-water pressure washing, soft wash, window, gutter, and solar panel cleaning for Westlake Village, CA homes and HOAs. Insured, no long-term contracts. Call (805) 464-7166."
    keywords="pressure washing Westlake Village, power washing Westlake Village CA, soft wash Westlake Village, window cleaning Westlake Village, exterior cleaning 91361"
    schemaDescription="Pressure washing, soft wash, window, gutter, solar panel, and carpet cleaning in Westlake Village, CA."
    heroText="Hot-water pressure washing and gentle soft washing for Westlake Village homes, HOAs, and commercial properties. Insured, locally owned, and no long-term contracts."
    localHeading="What Makes Westlake Village Properties Unique to Clean?"
    localText="Westlake Village sits on the Ventura County and Los Angeles County line, next to Thousand Oaks and Newbury Park. Many properties are stucco homes and HOA-managed communities where curb appeal and consistent upkeep matter. We clean driveways, walkways, roofs, windows, gutters, and solar panels for homeowners, HOAs, and property managers."
    neighborhoods={[]}
    localFactors={[
      'Stucco and painted exteriors are common, so we soft wash instead of using high pressure.',
      'HOA communities need dependable, insured vendors and flexible month-to-month or per-job agreements.',
      'Mature landscaping means we pre-soak plants and manage runoff on every job.',
    ]}
    faqs={[
      {
        question: 'Do you serve Westlake Village?',
        answer: 'Yes. We serve Westlake Village homeowners, HOAs, and businesses, along with neighboring Thousand Oaks and Newbury Park.',
      },
      {
        question: 'How much does pressure washing cost in Westlake Village, CA?',
        answer: 'Most driveway, patio, and walkway pressure washing jobs in Westlake Village run $150-$400, depending on square footage and surface type. We provide a free estimate before any work begins.',
      },
      {
        question: 'Do you work with HOAs in Westlake Village?',
        answer: 'Yes. We work with HOAs on a month-to-month or per-job basis and never require a long-term contract. We carry $1M-$2M general liability insurance and full workers’ compensation.',
      },
      {
        question: 'Will cleaning damage my stucco or landscaping?',
        answer: 'No. We soft wash stucco at low pressure, pre-soak landscaping, control runoff, and use 100% biodegradable, plant-safe, pet-safe detergents.',
      },
    ]}
  />
);

export default WestlakeVillagePage;
